<template>
  <div class="contractSales-device-dialog">
    <custom-dialog
      width="1400px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <div class="product-wrap">
          <div class="search-container">
            <el-form :inline="true" label-position="top">
              <el-form-item :label="$t('crm_contractSales_device_dialog.chan_pin_xing_hao')">
                <custom-select
                  :disabled="model.type === 'date_end_continue'"
                  v-model="formSearch.productCode"
                  url="productCodeSelectList"
                   :props="{ label: 'productName', value: 'productCode' }"
                  :placeholder="$t('Common.com_please_select')"
                  reserveKeyword
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item  :label="$t('crm_contractSales_device_dialog.she_bei_lei_xing')">
                <!-- deviceBizType -->
                <custom-select
                  :disabled="model.type === 'date_end_continue'"
                  v-model="formSearch.deviceBizType"
                  code="dms_device_biz_type"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_contractSales_device_dialog.ji_shen_hao')">
                <el-input
                  v-model="formSearch.bodyNum"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="advanced-footer">
              <div class="button-group">
                <el-button @click="clear">{{$t('Common.com_clear')}}</el-button>
                <el-button type="primary" @click="getLessee"> {{$t('Common.com_query')}} </el-button>
              </div>
            </div>
          </div>
          <div class="table-bd">
            <custom-table
              ref="table"
              type="radio"
              :data="rentLsseeList"
              v-model="leaseListSelect"
              :loading="isLoading"
              tableCode="contract_sales_device_list"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
              :filterArr="['action']"
            >
            </custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{
          $t('Common.com_cancel')
        }}</el-button>
        <el-button type="primary" @click="saveChoose">{{
          $t('Common.com_confirm')
        }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      rentLsseeList: [],
      isLoading: false,
      formSearch: {
        productCode: '',
        deviceBizType: '', // 设备业务类型，字典分组代码：dms_device_biz_type
        bodyNum: '',
        pageNum: 1,
        pageSize: 50,
      },
      totalRows: null,
      leaseListSelect: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.formSearch.productCode = this.model.productCode;
    this.formSearch.deviceBizType = this.model.deviceBizType;
    // this.initDialog();

    this.getLessee();
  },
  methods: {
    // 初始化
    initDialog: function () {
      // this.formSearch.bigCustomerId = this.model.bigCustomerId;
      if (this.model.type === 'date_end_continue') {
        this.$setFormatData(this.formSearch, this.model.row);
      }
      if (this.model.row) {
        this.formSearch.deviceBizType = this.model.row.nextDeviceBizType || '';
      }
    },
    // 获取关联列表
    getLessee: function () {
      this.$getJSON(apis.saleOrderDeviceSelectPage, this.formSearch).then((res) => {
        this.rentLsseeList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    clear: function () {
      this.getLessee();
    },
    // 保存新增
    saveChoose: function () {
      if (!this.leaseListSelect.deviceId) {
        this.$message({
          message: this.$t('crm_contractSales_device_dialog.qing_xuan_ze_she_bei'),
          type: 'error',
        });
        return;
      }

      this.$emit('success', this.leaseListSelect);
      this.visible = false;
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLessee();
    },
  },
};
</script>

<style lang="scss">
.contractSales-device-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 33.3%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
